import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import LoginPrompt from '../../../../pages/profiles/components/LogInPrompt';

const LoginMenu = ({ isOpen, scrolled }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        transition={{duration: 0.15}}
        className={`fixed inset-x-0 mx-4 bg-white-pure rounded-lg border-[1.5px] border-ink z-40 ${
          scrolled ? 'bottom-24' : 'top-16'
        }`}
      >
        <LoginPrompt message="Please sign in with Discord to continue"/>
      </motion.div>
    )}
  </AnimatePresence>
);

export default LoginMenu;
